class CustomImages extends HTMLElement {
  constructor() {
    super();

    this.slide = this;

    let dot = false;
    if (this.slide.hasAttribute("data-dots")) {
      dot = this.slide.getAttribute("data-dots");
    }
    this.flkty = new Flickity(this.slide, {
      cellAlign: "left",
      pageDots: dot,
      adaptiveHeight: false,
      prevNextButtons: false,
      fade: true,
      imagesLoaded: true,
    });

    if (this.hasAttribute("data-id")) {
      this.id = this.getAttribute("data-id");
      if (this.id) {
        this.nav = document.querySelector('.js-slider-thumbnails[data-id="' + this.id + '"]');
      }
    } else {
      this.nav = document.querySelector(".js-slider-thumbnails");
    }

    if (this.nav) {
      this.nav.querySelectorAll(".product-thumbnails-item").forEach((button) => button.addEventListener("click", this.onChangeSlide.bind(this)));
    }

    this.flkty.on("change", function (index) {
      this.nav = document.querySelector(".js-slider-thumbnails.selected");
      if (this.nav) {
        if (this.nav.querySelectorAll('.product-thumbnails-item[data-index="' + index + '"]').length > 0) {
          this.nav.querySelector(".product-thumbnails-item.slide-current").classList.remove("slide-current");
          this.nav.querySelector('.product-thumbnails-item[data-index="' + index + '"]').classList.add("slide-current");
        }
      }
    });
  }

  onChangeSlide(e) {
    if (e.target.closest(".product-thumbnails-item")) {
      this.nextIndex = e.target.closest(".product-thumbnails-item").getAttribute("data-index");
      if (this.nextIndex) {
        this.flkty.select(this.nextIndex);
      }
    }
  }
}

customElements.define("custom-images", CustomImages);

class CustomVariants extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector("select");
    if (!this.select) return;

    this.select.addEventListener("change", this.onVariantChange.bind(this));
  }

  onVariantChange(e) {
    if (document.querySelectorAll(".product-custom-raw").length > 0) {
      this.dataColor = e.target.options[e.target.selectedIndex].getAttribute("data-color");
      const classes = ["green", "yellow", "purple"];
      classes.forEach((c) => {
        if (document.querySelector(".product-custom-raw").classList.contains(c)) {
          document.querySelector(".product-custom-raw").classList.remove(c);
        }
      });
      document.querySelector(".product-custom-raw").classList.add(this.dataColor);
    }

    this.id = e.target.options[e.target.selectedIndex].getAttribute("data-slide");
    if (document.querySelectorAll('custom-images[data-id="' + this.id + '"]').length > 0) {
      document.querySelector("custom-images.selected").classList.remove("selected");
      document.querySelector('custom-images[data-id="' + this.id + '"]').classList.add("selected");
    }
    if (document.querySelectorAll('.js-slider-thumbnails[data-id="' + this.id + '"]').length > 0) {
      document.querySelector(".js-slider-thumbnails.selected").classList.remove("selected");
      document.querySelector('.js-slider-thumbnails[data-id="' + this.id + '"]').classList.add("selected");
    }
    if (document.querySelectorAll('.desc-product-wrap[data-id="' + this.id + '"]').length > 0) {
      document.querySelectorAll(".desc-product-wrap.active").forEach((elm) => elm.classList.remove("active"));
      document.querySelectorAll('.desc-product-wrap[data-id="' + this.id + '"]').forEach((elm) => elm.classList.add("active"));
      // document.querySelector('.desc-product-wrap.active').classList.remove('active');
      // document.querySelector('.desc-product-wrap[data-id="'+ this.id +'"]').classList.add('active');
    }
  }
}

customElements.define("custom-variants", CustomVariants);

class ShowDescription extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick() {
    document.querySelectorAll(".desc-product-wrap.active .description-truncate").forEach((elm) => (elm.style.display = "none"));
    document.querySelectorAll(".desc-product-wrap.active .description-full").forEach((elm) => (elm.style.display = "block"));
    // document.querySelector('.desc-product-wrap.active .description-truncate').style.display = 'none';
    // document.querySelector('.desc-product-wrap.active .description-full').style.display = 'block';
  }
}

customElements.define("show-description", ShowDescription);

class ProductReview extends HTMLElement {
  constructor() {
    super();

    var elem = this;
    var flkty = new Flickity(elem, {
      // options
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 10000,
      wrapAround: true,
    });
  }
}

customElements.define("product-review", ProductReview);

class DryReview extends HTMLElement {
  constructor() {
    super();
    (this.columnSelector = ".review-column"),
      (this.blockSelector = ".review-block"),
      (this.type = "horizonal"),
      (this.repeat = 1),
      (this.timing = this.dataset.timing ? Number(this.dataset.timing) : 16),
      (this.delay = 0),
      (this.staggered = "true" == this.dataset.staggered),
      (this.columns = this.querySelectorAll(this.columnSelector)),
      (this.started = !1),
      this.columns.forEach((e, t) => {
        const i = e.querySelector(this.blockSelector);
        this.handleLoop(e, i, t);
      });
  }

  animateTickertape(e, t, i) {
    const s = i.count,
      r = e,
      { distance: n } = i;
    let o = s + 1;
    (r.style.transitionTimingFunction = "linear"),
      (r.style.transitionProperty = "all"),
      "vertical" == this.type && this.staggered
        ? (1 === o && (o = 1),
          2 === o && (o = 4),
          3 === o && (o = 3),
          4 === o && (o = 2),
          (r.style.transitionDuration = (o + 1) * this.timing + "s"),
          (r.style.transform = `translate3d(0, -${n}px, 0)`))
        : "vertical" == this.type
          ? ((r.style.transitionDuration = `${this.timing}s`), (r.style.transform = `translate3d(0, -${n}px, 0)`))
          : ((r.style.transitionDuration = `${this.timing}s`), (r.style.transform = `translate3d(-${n}px, 0,  0)`));
    const a = this.staggered ? (o + 1) * (1e3 * this.timing) : 1e3 * this.timing;
    window.setTimeout(() => {
      (r.style.transitionDuration = "0s"), (r.style.transform = "translate3d(0, 0 ,0)"), this.handleLoop(e, t, s);
    }, a);
  }

  handleLoop(e, t, i) {
    if (this.started) {
      let s = "vertical" == this.type ? e.getBoundingClientRect().height : t.getBoundingClientRect().width;
      this.repeat && (s *= this.repeat),
        this.animateTickertape(e, t, {
          distance: s,
          count: i,
        });
    } else
      setTimeout(() => {
        this.started = !0;
        let s = "vertical" == this.type ? e.getBoundingClientRect().height : t.getBoundingClientRect().width;
        this.repeat && (s *= this.repeat),
          this.animateTickertape(e, t, {
            distance: s,
            count: i,
          });
      }, this.delay);
  }
}

customElements.define("dry-review", DryReview);

class DrySticky extends HTMLElement {
  constructor() {
    super();
    this.sticky = this;
    this.container = this.sticky.closest('.product-custom-info-wrap');

    if (!this.container) return;

    const callback = (entries, observer) => {
      for (const entry of entries) {
        if (!document.body.classList.contains('product-popup-opening')) {
          entry.isIntersecting ? this.sticky.classList.remove('active') : window.scrollY > 200 && this.sticky.classList.add('active');
        }
      }
    }
    const observer = new IntersectionObserver(callback, {
      threshold: 0.25,
    });
    observer.observe(this.container)
  }
}

customElements.define("dry-sticky", DrySticky);

class DryWeight extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('select');
    if (!this.select) return;
    this.select.addEventListener("change", (e) => {
      e.preventDefault();
      this.url = e.target.options[e.target.selectedIndex].getAttribute("data-url");
      window.location.href = this.url;
    });
  }
}

customElements.define("dry-weight", DryWeight);

class DryImages extends HTMLElement {
  constructor() {
    super();

    this.images = this.querySelectorAll('.product-custom-thumbnails__item');
    this.images.forEach((image) => {
      image.addEventListener("click", this.openPopup.bind(this));
    });

    this.closePopupBtn = document.querySelector('.js-popup-images-close');
    if (this.closePopupBtn) {
      this.closePopupBtn.addEventListener('click', this.closePopup.bind(this));
    }

    this.init();
  }

  init() {
    this.slide = document.querySelector('.product-custom-popup-images');
    this.flkty = new Flickity(this.slide, {
      cellAlign: "left",
      adaptiveHeight: false,
      prevNextButtons: true,
      pageDots: false,
      fade: true,
      imagesLoaded: true,
      wrapAround: true
    });
  }

  openPopup(e) {
    e.preventDefault();
    this.currentIndex = e.currentTarget.getAttribute("data-index");
    this.flkty.select(this.currentIndex);

    setTimeout(() => {
      if (document.querySelectorAll('dry-sticky').length > 0) {
        this.atcIsSticky = document.querySelector('dry-sticky').classList.contains('active');
        if (window.innerWidth < 750) {
          if (!this.atcIsSticky) {
            document.querySelector('dry-sticky').classList.add('active');
          }
  
          let stickyHeight = document.querySelector('dry-sticky').offsetHeight - 1;
          document.querySelector('.product-custom-popup').style.height = `calc(100% - ${stickyHeight}px)`;
        } else {
          document.querySelector('.product-custom-popup').style.height = `100%`;
        }
      }
      
      document.body.classList.add('product-popup-opening');
    }, 500);
  }

  closePopup() {
    if (document.querySelectorAll('dry-sticky').length > 0 && window.innerWidth < 750 && !this.atcIsSticky) {
      document.querySelector('dry-sticky').classList.remove('active');
    }

    document.body.classList.remove('product-popup-opening');
  }
}

customElements.define("dry-images", DryImages);

class DryTags extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.container.addEventListener("click", this.openPopup.bind(this));

    this.closeBtns = document.querySelectorAll('close-review');
    this.closeBtns.forEach((btn) => {
      btn.addEventListener("click", this.closePopup.bind(this));
    });

    this.allReviews = document.querySelectorAll('all-reviews');
    this.allReviews.forEach((btn) => {
      btn.addEventListener("click", this.scrollToReviews.bind(this));
    });
  }

  openPopup() {
    document.body.classList.add('reviews-draw-opening');
  }

  closePopup() {
    document.body.classList.remove('reviews-draw-opening');
  }

  scrollToReviews() {
    this.closePopup();
    
    if (document.querySelectorAll('#yotpo-reviews-main-widget').length > 0) {
      const mainYotpoWidget = document.querySelector("#yotpo-reviews-main-widget");
      
      // Get the position relative to the viewport
      const rect = mainYotpoWidget.getBoundingClientRect();
      // Calculate the scroll position relative to the document
      const scrollTop = (window.pageYOffset + rect.top - 100);
      // Scroll smoothly to the widget
      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }
  }
}

customElements.define("dry-tags", DryTags);

window.addEventListener("pageshow", () => {
  document.querySelectorAll("dry-weight select").forEach((select) => {
    let index = select.getAttribute("data-index");
    select.selectedIndex = index;
    select.style.opacity = "1";
  });
});

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll('.all-reviews-url').length > 0) {
    document.querySelector('.all-reviews-url').addEventListener('click', (e) => {
      e.preventDefault();
      if (document.querySelectorAll('#yotpo-reviews-main-widget').length > 0) {
        const mainYotpoWidget = document.querySelector("#yotpo-reviews-main-widget");
        mainYotpoWidget.scrollIntoView({ behavior: "smooth" });
      } else {
        window.location.href = e.currentTarget.getAttribute('href');
      }
    })
  }
});